import { Directive, HostListener, Input } from "@angular/core";

import { DatatableComponent } from "@shared/components/datatable/datatable.component";
import { RowTable } from "@shared/schemas/row-table";

@Directive({
	selector: "[appRowExpand]",
	standalone: false
})
export class RowExpandDirective {
	@Input("appRowExpand") data!: RowTable;

	constructor(private table: DatatableComponent) {}

	@HostListener("click") onClick(): void {
		this.table.toggleRow(this.data);
	}
}
